import axios from 'axios';
import api from '../../config.json'
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import swal from 'sweetalert';
import validation from '../../utill/validation';
import joi from 'joi'
import Loading from '../../utill/LoadingComponent';

const ListForm = ({ history ,Heading}) => {
  const [formData, setFormData] = useState({ contents: [] });
  const [content, setContent] = useState("");
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const handleOnChange = (e) => {
    const obj = { ...formData };
    const { name, value } = e.currentTarget;
    obj[name] = value;
    const error = validation.validateProperty(e.currentTarget, schema)
    setErrors(error || {})
    setFormData(obj);
  }

  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.action == 'view') {
      setFormData(location.state.data)
    }
    if (location.state && location.state.action == 'update') {
      setFormData(location.state.data)
    }
  }, [location])
useEffect(() => {
Heading('List Master')
}, [])

  const schema = {
    ListName: joi.required().label('List Name'),
    contents: joi.array().min(1).label('Min 1 content required'),
    _id: joi.string()
  }

  const handleAddList = () => {
    const obj = { ...formData }
    if (content) {
      if (obj.contents.some(x=>x.toLowerCase()==content.toLowerCase())) {
        swal("Content already exist in list.", { dangerMode: true })
      } else {
        obj.contents.push(content)
        const error = validation.validateProperty({ name: "contents", value: obj.contents }, schema)
        setErrors(error || {})
        setFormData(obj);
        setContent("")
      }
    }

  }

  const onRemove = (idx) => {
    const obj = { ...formData };
    obj.contents.splice(idx, 1);
    setFormData(obj)
  }

  const handleSave = () => {
    delete formData.__v
    delete formData.createdAt
    delete formData.updatedAt
    const error = validation.validate(formData, schema)
    if (error) {
      setErrors(error)
      return
    }
    setErrors(error || {})
    setLoader(true)
    if (location.state && location.state.action == "update") {
      axios.patch(api.api + 'ListMaster/'+formData._id, formData)
        .then((result) => {
          swal('Update Successfully');
          history.push('/setting/content/list');
          setLoader(false)
        })
        .catch((err) => {
          swal(`${err}`);
          setLoader(false)
        })
    } else {
      axios.post(api.api + 'ListMaster', formData)
        .then((result) => {
          swal('Save Successfully');
          history.push('/setting/content/list');
          setLoader(false)
        })
        .catch((err) => {
          swal(`${err}`);
          setLoader(false)
        })
    }

  }
  return (

    <React.Fragment>
      {loader ? <Loading /> : <></>}
      <div className=" border ">
        <div className="row justify-content-center ">
          <div className="col-sm-4">
            <div className="form-group text-center">
              <label htmlFor="componentid">List Name</label>
              <input
                disabled={location.state && location.state.action == 'view'}
                className="form-control form-control-sm"
                required
                type="text"
                onChange={handleOnChange}
                name="ListName"
                placeholder="Enter List Name..."
                defaultValue={formData.ListName || ""}
              />
              {errors.ListName && <div className="alert small alert-danger">{errors['ListName']}</div>}
            </div>
          </div>
        </div>
        <div className="row justify-content-center ">
          <div className="col-sm-2 overflow-auto">
          </div>
          {location.state && location.state.action !== 'view' && <div className="col-sm-4 overflow-auto">
            <div className="form-group text-center">
              <label htmlFor="componentid">Content</label>
              <input
                disabled={location.state && location.state.action == 'view' ? true : false}
                value={content}
                className="form-control form-control-sm"
                required
                type="text"
                onChange={(e) => setContent(e.currentTarget.value)}
                name="Content"
                placeholder="Enter Content..."
              />
            </div>
            {errors.contents && <div className="alert small alert-danger">{errors['contents']}</div>}
          </div>}
          <div className="col-sm-4 mt-4">
            {location.state && location.state.action !== 'view' && <div className="form-group">
              <button onClick={() => handleAddList()} className='btn-sm btn-primary'>+ Add To List</button>
            </div>}
          </div>
        </div>
        {formData.contents.length > 0 && <div className="row justify-content-center ">
          <div className="col-sm-6 overflow-auto">
            <h5 htmlFor="componentid">List Of Contents</h5>
            <ul class="list-group">
              {formData.contents.map((one, index) => {
                return <li class="list-group-item d-flex justify-content-between align-items-center">
                  {one}
                  {location.state && location.state.action !== 'view' && <button disabled={location.state && location.state.action == 'view' ? true : false} onClick={() => onRemove(index)} className="badge badge-primary badge-pill cursor-pointer">remove</button>}
                </li>
              })}
            </ul>
          </div>
        </div>}
        <div className='row text-center mt-2'>
          {!(location.state && location.state.action == 'view') && <div className='col-sm-12'>
            <button onClick={handleSave} className="btn-sm btn-primary">Submit</button>
            <button onClick={() => history.push('/setting/content/list')} className="btn-sm btn-primary ml-4">Cancel</button>
          </div>}
        </div>
      </div>


    </React.Fragment>
  );
}

export default ListForm;